import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";

type HandlerType = Handler<{}, StoreHandlerProps>;

export const DispatchSetInitialValues: HandlerType = props => {
    const account = getCurrentAccountState(props.getState()).value;
    const baseEditingAccount = props.getState().pages.accountSettings.editingAccount;

    if (!account || !baseEditingAccount) {
        return;
    }

    props.dispatch({
        type: "Store/Pages/AccountSettings/SetInitialValues",
        account,
        baseEditingAccount,
    });
};

export const chain = [DispatchSetInitialValues];

const setInitialValues = createHandlerChainRunnerOptionalParameter(chain, {}, "SetInitialValues");
export default setInitialValues;
